<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>基础数据</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/major/list'}">专业管理</el-breadcrumb-item>
        <el-breadcrumb-item>科目管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">科目管理</h2>
        </div>
        <div class="right">
          <el-button class="button" type="primary" @click="handleSubjectCreate">添加科目</el-button>
        </div>
      </div>
    </div>
    <div class="info card">
      <div class="info-item">
        <span class="label">专业名称：</span>
        <span class="value">{{major.name}}</span>
      </div>
      <el-divider class="divider" direction="vertical"></el-divider>
      <div class="info-item">
        <span class="label">专业代码：</span>
        <span class="value">{{major.code}}</span>
      </div>
      <el-divider class="divider" direction="vertical"></el-divider>
      <div class="info-item">
        <span class="label">学习方式：</span>
        <span class="value">{{major.learn === 1 ? '全日制' : '非全日制'}}</span>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="subject_name"
            label="科目名称"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="subject_code"
            label="科目代码"
            min-width="160"
            align="center">
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                disabled
                @click="handleToSubjectRemove(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <MajorSubjectCreate :visible="createDialog" :major="major" @close="createDialog = false" @submit="fetchMajorList"></MajorSubjectCreate>
  </div>
</template>

<script>
import MajorSubjectCreate from '@/components/dialog/major/MajorSubjectCreate'
import { majorSubjectList, majorSubjectDestroy, majorOne } from '@/api/common'

export default {
  components: {
    MajorSubjectCreate
  },
  data() {
    return {
      createDialog: false,
      editRow: {},
      query:  {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      major: {},
      results: []
    }
  },
  created() {
    this.parseQuery()
    this.fetchMajorInfo()
  },
  methods: {
    fetchMajorInfo() {
      majorOne({id: this.$route.params.majorId}).then(res => {
        this.major = res

        this.fetchMajorList()
      })
    },
    // 科目列表请求
    fetchMajorList() {
      let params = {...this.query}
      params.major_code = this.major.code
      if (this.major.college_code) {
        params.college_code = this.major.college_code
      }
      majorSubjectList(params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchMajorList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchMajorList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchMajorList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchMajorList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '2': '关闭'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 科目创建
    handleSubjectCreate() {
      this.createDialog = true
    },
    // 科目删除
    handleToSubjectRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        majorSubjectDestroy({id: row.id}).then(res => {
          this.$message.success(`删除成功`)
          this.fetchMajorList()
        })
      }).catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .info {
    display: flex;
    margin-top: 10px;

    .info-item {
      .label {
        color: #909399;
      }
      .value {
        // margin-left: 5px;
      }
    }
    .divider{
      margin: 0 20px;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {

    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
